import { type ReactNode } from 'react';

import styles from './listing-filter-section.module.scss';

interface ListingFilterSectionProps {
  children: ReactNode;
  title: string;
}

export default function ListingFilterSection(props: ListingFilterSectionProps) {
  const {
    children,
    title,
  } = props;

  return (
    <div className={styles.filterSection}>
      <div className={styles.filterSection_title}>{title}</div>
      {children}
    </div>
  );
}
